/* eslint-disable no-param-reassign */

// Redux slice for Baby SKU/plan list.

import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import monitoringService from 'infrastructure/serviceHandlers/Monitoring/Monitoring';
import { getBabyPlans } from 'services/api/babyApi';
import { TPlanList } from 'typings';
import { TBabyPlanState } from 'typings/babyTypes';

// Thunk: fetches Baby SKUs for the given country.
export const fetchBabyPlans = createAsyncThunk(
  'spaces/fetchBabyPlans',
  async (payload: string, thunkAPI) => {
    try {
      const response = await getBabyPlans(payload);
      return response.data;
    } catch (error) {
      monitoringService.captureException(error, {
        tags: {
          feature: 'fetchBabyPlans',
          error_type: 'api_error'
        },
        extra: {
          payload
        }
      });
      return thunkAPI.rejectWithValue('failed');
    }
  }
);

const initialPlanState: TBabyPlanState = {
  babyPlanList: [],
  isLoading: false
};

export const babyPlansSlice = createSlice({
  name: 'babyPlans',
  initialState: initialPlanState,
  reducers: {
    // Reset cached SKUs
    clearBabyPlansData: (state) => {
      state.babyPlanList = [];
    },
    // Imperative override of the SKU list — kept for parity with petPlansReducer; not
    // currently wired but available if a page needs to seed plans without re-fetching.
    updateBabyPlansData: (state, action) => {
      state.babyPlanList = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchBabyPlans.fulfilled, (state, action) => {
        state.isLoading = false;
        state.babyPlanList = action.payload as TPlanList[];
      })
      .addCase(fetchBabyPlans.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchBabyPlans.rejected, (state) => {
        state.isLoading = false;
      });
  }
});

export const { clearBabyPlansData, updateBabyPlansData } =
  babyPlansSlice.actions;

export default babyPlansSlice.reducer;
